import { IconButton } from "@prophero-ds/cx-react";

interface BackButtonProps {
  id?: string;
  onClick: () => void;
  ariaLabel: string;
  className?: string;
}

function BackButton({ id, onClick, ariaLabel, className }: BackButtonProps) {
  return (
    <IconButton
      type="button"
      id={id}
      icon={{ name: "chevron-left" }}
      variant="secondary"
      size="small"
      onClick={() => void onClick()}
      aria-label={ariaLabel}
      className={className}
    />
  );
}

export default BackButton;
